import axios from "axios";
import { getRotaPath } from "../lib/white-cache";

export const deleteExtraShiftUser = async (id: string): Promise<boolean> => {
  try {
    await axios.delete(`${getRotaPath()}/ExtraShiftUser/${id}`);
    return true;
  } catch (error) {
    return false;
  }
};
